module.exports = __webpack_public_path__ + "img/360ext-red.619c2e98.svg";